import { WarehouseIcon } from '@phosphor-icons/react';
import { useState } from 'react';
import { cn } from '@skupreme/shared/ui';
import { flagImages } from '../legacy-bridge';

const SIZES = {
  md: {
    box: 'sk:size-9',
    image: 'sk:size-5',
    flag: 'sk:h-3.5 sk:w-5',
    icon: 18,
  },
  lg: {
    box: 'sk:size-12',
    image: 'sk:size-7',
    flag: 'sk:h-4.5 sk:w-6',
    icon: 22,
  },
};

type ProviderMarkProps = {
  logoUrl?: string;
  /** Shown when there is no logo; without it the mark is a warehouse. */
  countryCode?: string;
  size?: keyof typeof SIZES;
};

/** The provider's logo in a tile, its country's flag, or a warehouse (also when the logo fails to load). */
export function ProviderMark({
  logoUrl,
  countryCode,
  size = 'md',
}: ProviderMarkProps) {
  const sizes = SIZES[size];
  /* EN-4432: a logo that fails to load (a missing S3 object) shows what the mark shows with no logo. */
  const [failedLogo, setFailedLogo] = useState<string>();
  const flag = countryCode ? flagImages[countryCode.toUpperCase()] : undefined;

  return (
    <div
      className={cn(
        'sk:flex sk:shrink-0 sk:items-center sk:justify-center sk:rounded-card sk:border sk:border-border-subtle sk:bg-surface',
        sizes.box,
      )}
    >
      {logoUrl && logoUrl !== failedLogo ? (
        <img
          src={logoUrl}
          alt=""
          onError={() => setFailedLogo(logoUrl)}
          className={cn('sk:rounded-xs sk:object-contain', sizes.image)}
        />
      ) : flag ? (
        <img
          src={flag}
          alt=""
          className={cn('sk:rounded-xs sk:object-cover', sizes.flag)}
        />
      ) : (
        <WarehouseIcon size={sizes.icon} className="sk:text-fg-secondary" />
      )}
    </div>
  );
}
